import { AxiosError, isAxiosError } from 'axios';

interface IForgotPasswordRateLimitedResponse {
  message?: string;
  error?: string;
}

export class ForgotPasswordRateLimitedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ForgotPasswordRateLimitedError';
  }

  static fromAxiosError(error: unknown): ForgotPasswordRateLimitedError | null {
    if (!isAxiosError(error)) {
      return null;
    }

    const axiosError = error as AxiosError<IForgotPasswordRateLimitedResponse>;

    if (axiosError.response?.status === 429) {
      const message =
        axiosError.response.data?.message ||
        axiosError.response.data?.error ||
        'Too many attempts, please try again in a few minutes.';
      return new ForgotPasswordRateLimitedError(message);
    }

    return null;
  }
}
